import { useEffect } from 'react';

/**
 * Google Analytics Component
 * This component initializes Google Analytics and tracks page views
 * Replace GA_MEASUREMENT_ID with your actual GA4 Measurement ID
 */
const Analytics = () => {
  const GA_MEASUREMENT_ID = 'G-G943K258MF'; // Replace with your actual GA4 Measurement ID

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      // Initialize GA with your measurement ID
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_title: document.title
      });

      // Function to track section views in single-page app
      const trackSectionViews = () => {
        // Get the current hash (section)
        const hash = window.location.hash || '#home';
        
        // Track the section view
        window.gtag('event', 'section_view', {
          'section_id': hash.replace('#', ''),
          'page_title': document.title + ' - ' + hash.replace('#', '')
        });
        
        // Also send as a pageview
        window.gtag('config', GA_MEASUREMENT_ID, {
          page_path: window.location.pathname + hash,
          page_title: document.title + ' - ' + hash.replace('#', '')
        });
      };

      // Add listener for hash changes (section navigation)
      window.addEventListener('hashchange', trackSectionViews);
      
      // Track initial section
      trackSectionViews();

      // Clean up
      return () => {
        window.removeEventListener('hashchange', trackSectionViews);
      };
    }
  }, []);

  return null; // This component doesn't render anything
};

// Custom event tracking function you can use throughout your app
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

export default Analytics;
